/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Export_PlayersInputs */



/**
* | output |
* | --- |
* | "Export the player list (CSV)" |
*
* @param {Tools_Export_PlayersInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tools_export_players = /** @type {((inputs?: Tools_Export_PlayersInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Export_PlayersInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter la liste des joueurs (CSV)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar la lista de jugadores (CSV)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Exportar a lista de jogadores (CSV)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta l'elenco dei giocatori (CSV)")
	return /** @type {LocalizedString} */ ("Export the player list (CSV)")
});